import { isTextSelection } from "@tiptap/core";
import { EditorState } from "@tiptap/pm/state";

import { CHECK_FOR_UNDERSTANDING_BLOCK } from "@/view/TiptapArticleBody/extensions/ChecksForUnderstanding";

export interface IShouldShowProps {
  state: EditorState;
  from: number;
  to: number;
}

export const shouldShow = ({ state, from, to }: IShouldShowProps) => {
  const { doc, selection } = state;
  const { empty } = selection;

  const isEmptyTextBlock =
    empty || (!doc.textBetween(from, to).length && isTextSelection(selection));

  const resolvedFromPos = doc.resolve(from);
  const resolvedToPos = doc.resolve(to);
  const nodeFrom = resolvedFromPos.node();
  const nodeTo = resolvedToPos.node();

  // Do not show Annotation if within the CheckForUnderstanding block
  const isCheckForUnderstandingBlock = [nodeFrom, nodeTo].some(
    (node) => node?.type.name === CHECK_FOR_UNDERSTANDING_BLOCK,
  );

  return !(isEmptyTextBlock || isCheckForUnderstandingBlock);
};
